import { ReportElementType } from "./defs";
var Color;
(function (Color) {
  Color["DEFAULT"] = "gray";
  Color["EVENT"] = "inherit";
  Color["MODULE"] = "#03A9F4";
  Color["RESOURCE"] = "#4CAF50";
})(Color || (Color = {}));
;
var FontWeight;
(function (FontWeight) {
  FontWeight["BOLD"] = "bold";
  FontWeight["LIGHTER"] = "lighter";
})(FontWeight || (FontWeight = {}));
;
var defaultReportType = -1;
/**
 * 生成样式
 * @param {keyof colors} type 颜色类型
 * @param {string} weight 字重
 */
function style(color) {
  var weight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FontWeight.BOLD;
  return "color: ".concat(color, "; font-weight: ").concat(weight);
}
/**
 * 日志输出
 * @param {boolean} silent
 * @returns {ReportLogger}
 */
export default function createLogger() {
  var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  /**
   * @param {ReportEvent} event
   * @param {ReportParams} params
   */
  function logger(event, params) {
    var _a, _b, _c, _d;
    if (silent) {
      return;
    }
    var type = (_a = params === null || params === void 0 ? void 0 : params.f_type) !== null && _a !== void 0 ? _a : defaultReportType;
    (_b = console.groupCollapsed) === null || _b === void 0 ? void 0 : _b.call(console, "%c[reporter] %c(".concat(type === ReportElementType.PAGE ? 'pv' : event).concat(type === ReportElementType.MODULE ? '.module' : '', ")"), style(Color.DEFAULT, FontWeight.LIGHTER), style(Color.EVENT));
    if (params) {
      var module = params.f_module,
        resource = params.f_resource;
      if (module) {
        console.log('%c f_module:', style(Color.MODULE), module);
      }
      if (resource) {
        console.log('%c f_resource:', style(Color.RESOURCE), resource);
      }
      (_c = console.table) === null || _c === void 0 ? void 0 : _c.call(console, params);
    }
    (_d = console.groupEnd) === null || _d === void 0 ? void 0 : _d.call(console);
  }
  return logger;
}